import { api } from '../api';
import { Email } from '../types/email';

export async function getProjectEmails(projectId: string): Promise<Email[]> {
  const response = await api.get(
    `admin/projects/${projectId}/emails?include=mailbox,forwarded`,
  );
  return response.json();
}
